import React, { useEffect, useRef } from 'react';
export var Commands;
(function (Commands) {
    Commands[Commands["play"] = 0] = "play";
    Commands[Commands["pause"] = 1] = "pause";
    Commands[Commands["stop"] = 2] = "stop";
    Commands[Commands["mute"] = 3] = "mute";
    Commands[Commands["unMute"] = 4] = "unMute";
})(Commands || (Commands = {}));
var YouTubeIframe = function (props) {
    var videoId = props.videoId, command = props.command;
    var iframeVideoRef = useRef(null);
    var sendCommand = function (func, args) {
        var iframe = iframeVideoRef.current;
        if (iframe) {
            var src = iframe.getAttribute('src');
            if (src) {
                if (iframe.contentWindow) {
                    iframe.contentWindow.postMessage(JSON.stringify({
                        'event': 'command',
                        'func': func,
                        'args': args || []
                    }), '*');
                }
            }
        }
    };
    useEffect(function () {
        switch (command) {
            case Commands.play:
                sendCommand('playVideo');
                break;
            case Commands.stop:
                sendCommand('stopVideo');
                break;
            case Commands.pause:
                sendCommand('pauseVideo');
                break;
            case Commands.mute:
                sendCommand('mute');
                break;
            case Commands.unMute:
                sendCommand('unMute');
                break;
        }
    }, [command]);
    return (React.createElement("iframe", { title: videoId, ref: iframeVideoRef, frameBorder: '0', allow: 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture', src: "https://www.youtube.com/embed/" + videoId + "?modestbranding=1&enablejsapi=1&controls=0" }));
};
export default YouTubeIframe;
